// Reusable confirm modal untuk "Buat baru?" / "Hapus proyek?".

export function showConfirm({
  title,
  message,
  confirmLabel = 'Ya',
  cancelLabel = 'Batal',
  danger = false,
}) {
  return new Promise((resolve) => {
    const overlay = document.createElement('div')
    overlay.className = 'tm-modal-backdrop'
    overlay.innerHTML = `
      <div class="tm-modal" role="alertdialog" aria-label="${title}">
        <h2>${title}</h2>
        <p>${message}</p>
        <div class="tm-modal__actions">
          <button data-action="cancel" class="tm-modal__btn-secondary">${cancelLabel}</button>
          <button data-action="confirm" class="tm-modal__btn-${danger ? 'danger' : 'primary'}">${confirmLabel}</button>
        </div>
      </div>
    `
    overlay.querySelector('[data-action="cancel"]').addEventListener('click', () => {
      overlay.remove()
      resolve(false)
    })
    overlay.querySelector('[data-action="confirm"]').addEventListener('click', () => {
      overlay.remove()
      resolve(true)
    })
    document.body.appendChild(overlay)
  })
}
